const RejectIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<path
				d="M19.5 1.75C21.019 1.75 22.25 2.98122 22.25 4.5V19.5C22.25 21.0188 21.019 22.25 19.5 22.25H4.5C2.981 22.25 1.75 21.0188 1.75 19.5V4.5C1.75 2.98122 2.981 1.75 4.5 1.75H19.5ZM4.5 3.25C3.81 3.25 3.25 3.80964 3.25 4.5V19.5C3.25 20.1904 3.81 20.75 4.5 20.75H19.5C20.19 20.75 20.75 20.1904 20.75 19.5V4.5C20.75 3.80964 20.19 3.25 19.5 3.25H4.5ZM14.47 8.46973C14.763 8.1769 15.237 8.17686 15.53 8.46973C15.823 8.76262 15.823 9.23742 15.53 9.53027L13.061 12L15.53 14.4697C15.823 14.7626 15.823 15.2374 15.53 15.5303C15.237 15.8231 14.763 15.823 14.47 15.5303L12 13.0605L9.53 15.5303C9.237 15.8229 8.763 15.8228 8.47 15.5303C8.177 15.2374 8.177 14.7626 8.47 14.4697L10.939 12L8.47 9.53027C8.177 9.23737 8.177 8.76256 8.47 8.46973C8.763 8.17715 9.237 8.17711 9.53 8.46973L12 10.9395L14.47 8.46973Z"
				fill={color}
			/>
		</svg>
	);
};

export default RejectIcon;
